import React from 'react'
import clsx from 'clsx'

import { AvatarWrapper } from './wrapper'
import { CommonProps } from './types/common'
import { sizeClassnames, shapeClassnames } from './utils/common'

export interface ImageAvatarProps extends CommonProps {
  src: string
  alt: string
}

export const ImageAvatar = React.forwardRef<any, ImageAvatarProps>(
  (props, ref: any) => {
    const {
      src,
      alt,
      size = 'md',
      shape = 'circle',
      showNotification = false,
      notificationStatus = 'default',
      notificationPosition = 'top-right',
      id,
      className,
    } = props

    return (
      <AvatarWrapper
        id={id}
        ref={ref}
        rootClassName={clsx('inline-block relative', className)}
        size={size}
        shape={shape}
        showNotification={showNotification}
        notificationStatus={notificationStatus}
        notificationPosition={notificationPosition}
      >
        <img
          className={clsx(sizeClassnames[size].main, shapeClassnames[shape])}
          src={src}
          alt={alt}
        />
      </AvatarWrapper>
    )
  }
)
